/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

interface UiFormInnerProps {
    title?: React.ReactNode
    actions?: React.ReactNode
    children: React.ReactNode | React.ReactNode[]
    className?: string
}

const UiFormInner = (props: UiFormInnerProps) => {
    return (
        <div
            className={clsx(
                'UiFormInner grow bg-white text-gray-900',
                'dark:bg-gray-900 dark:text-gray-100 dark:border-gray-800/50',
                props.className
            )}
        >
            {(props.title || props.actions) && (
                <header
                    className={clsx(
                        'UiFormInnerHeader relative flex items-center justify-between h-10 bg-gray-50 border-b border-gray-100',
                        'dark:bg-gray-800 dark:border-gray-800/50'
                    )}
                >
                    <div className="UiFormInnerAccent absolute left-0 top-0 bottom-0 w-1 bg-cta-light dark:bg-cta-500" />

                    {props.title && (
                        <div
                            className={clsx(
                                'UiFormInnerTitle inline-flex items-center h-full text-xs font-extrabold uppercase tracking-widest transition-all pl-3',
                                'text-cta-600 dark:text-cta-400'
                            )}
                        >
                            {props.title}
                        </div>
                    )}
                    {props.actions && (
                        <div className={clsx('UiFormInnerActions ml-auto pr-3 flex items-center h-full gap-2')}>
                            {props.actions}
                        </div>
                    )}
                </header>
            )}
            <div className="UiFormInnerContent pt-3 min-h-0 flex flex-col">
                <main className={clsx('UiFormInnerMain space-y-6 min-h-0')}>
                    {props.children}
                </main>
            </div>
        </div>
    )
}

export default UiFormInner
